import { useState, useEffect, useRef } from "react";
import { Box, Typography, Button } from "@mui/material";
import Barcode from "react-barcode";
import ReactToPrint from "react-to-print";
import { useSearchParams } from "react-router-dom";
import { rsAddress, rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { UseOrders } from "../OrdersPage/UseOrders";
import { toMoney } from "../../util/Utils";

export default function AddressPrint(props) {
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { addressPrint } = UseOrders();
  const [msAddress, setMsAddress] = useRecoilState(rsAddress);
  const [searchParams, setSearchParams] = useSearchParams();
  const [data, setData] = useState();
  const componentRef = useRef();

  const [addresPrint, setAddresPrint] = useState(
    localStorage.getItem("addresPrint")
      ? localStorage.getItem("addresPrint").replace(/['"]+/g, "")
      : ""
  );
  const [sellerAddresPrint, setSellerAddresPrint] = useState(
    localStorage.getItem("sellerAddresPrint")
      ? localStorage.getItem("sellerAddresPrint").replace(/['"]+/g, "")
      : ""
  );
  useEffect(() => {
    setMsAddress(true);
    setProgress(true);
    if (searchParams.get("oid")) {
      addressPrint(searchParams.get("oid"), (callback) => {
        setProgress(false);
        setData(callback);
      });
    }
  }, [searchParams]);

  return (
    data && (
      <>
        <ReactToPrint
          copyStyles={true}
          trigger={() => (
            <Button
              sx={{ m: 2, width: "100px" }}
              aria-label="Print Licensee profile"
              aria-haspopup="false"
              color="secondary"
              variant="contained"
            >
              چاپ
            </Button>
          )}
          content={() => componentRef.current}
        />
        <Box
          sx={{
            width: "14cm",
            m: 2,
            direction: "ltr",
          }}
          ref={componentRef}
        >
          <Box
            sx={{
              border: ".3px solid black",
            }}
          >
            <Box sx={{ borderBottom: ".3px solid black" }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  p: 2,
                  py: 1,
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Typography
                    fontWeight="bold"
                    variant="body1"
                    sx={{
                      mr: 1,
                      fontSize: "13px",
                    }}
                  >
                    فرستنده :
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "13px",
                    }}
                    variant="subtitle2"
                  >
                    {data.seller}
                  </Typography>
                </Box>

                <Box>
                  <Typography
                    sx={{
                      fontSize: "13px",
                    }}
                    variant="subtitle2"
                  >
                    {data.shamsiLogDate}
                  </Typography>
                </Box>
              </Box>
              {sellerAddresPrint && sellerAddresPrint == " با آدرس مبدا" && (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    p: 2,
                    py: 1,
                  }}
                >
                  <Typography sx={{ fontSize: "13px" }} variant="subtitle2">
                    آدرس مبدا : {data.sellerAddress}
                  </Typography>
                </Box>
              )}

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  p: 2,
                  py: 0,
                  pb: 1,
                }}
              >
                <Typography
                  sx={{
                    fontSize: "13px",
                  }}
                  variant="subtitle2"
                >
                  زمان ارسال : {data.deliveryTime}
                </Typography>
                <Typography
                  sx={{
                    // fontSize: "13px",
                    fontWeight: "bold",
                  }}
                  variant="h5"
                >
                  {data.deliveryType ? data.deliveryType : "-"}
                </Typography>
              </Box>
            </Box>
            <Box sx={{ p: 2, pt: 0, pb: 5 }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  mb: 0.5,
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Typography
                    sx={{ fontSize: "13px", mr: 1 }}
                    variant="body1"
                    fontWeight="bold"
                  >
                    گیرنده :
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "13px",
                    }}
                    variant="subtitle2"
                  >
                    {data.fullName}
                  </Typography>
                </Box>
                <Box>
                  <Barcode
                    fontSize={12}
                    width={1.5}
                    height={30}
                    margin={0}
                    value={data.id.toString()}
                  />
                </Box>
              </Box>
              <Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    mb: 2,
                    width: "100%",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "13px",
                    }}
                    variant="subtitle2"
                  >
                    استان : {data.province}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "13px",
                    }}
                    variant="subtitle2"
                  >
                    شهر : {data.city}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "13px",
                    }}
                    variant="subtitle2"
                  >
                    شماره تماس : {data.mobile}
                  </Typography>
                </Box>
                <Typography
                  sx={{ fontSize: "13px", mb: 2 }}
                  variant="subtitle2"
                >
                  آدرس : {data.address}
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "13px",
                    }}
                    variant="subtitle2"
                  >
                    کد پستی : {data.postCode}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "13px",
                    }}
                    variant="subtitle2"
                  >
                    هدیه : {data.giftName ? data.giftName : ""}
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>
          {addresPrint && addresPrint == "با اقلام" && (
            <Box
              sx={{
                border: ".3px solid black",
                borderBottom: 0,
                mt: 2,
              }}
            >
              <Box
                sx={{
                  borderBottom: ".3px solid black",
                }}
                display="grid"
                gridTemplateColumns="repeat(12, 1fr)"
              >
                <Box
                  gridColumn="span 7"
                  sx={{ borderRight: ".3px solid black", py: 1, px: 2 }}
                ></Box>
                <Box gridColumn="span 4" sx={{ py: 1, px: 2 }}>
                  <Typography
                    variant="body2"
                    sx={{ fontSize: "13px", display: "flex" }}
                  >
                    سفارش :{" "}
                    <Typography
                      variant="body2"
                      sx={{ ml: 2, fontSize: "15px", fontWeight: "bold" }}
                    >
                      {data.id}
                    </Typography>
                  </Typography>
                </Box>
              </Box>
              <Box
                sx={{
                  borderBottom: ".3px solid black",
                }}
                display="grid"
                gridTemplateColumns="repeat(12, 1fr)"
                // gap={1}
              >
                <Box gridColumn="span 2">
                  <Typography
                    variant="body2"
                    sx={{
                      fontSize: "12px",
                      textAlign: "center",
                      py: 1,
                      borderRight: ".3px solid black",
                    }}
                  >
                    کد محصول
                  </Typography>
                </Box>
                <Box gridColumn="span 5">
                  <Typography
                    variant="body2"
                    sx={{
                      py: 1,
                      borderRight: ".3px solid black",
                      fontSize: "12px",
                      textAlign: "center",
                    }}
                  >
                    نام محصول
                  </Typography>
                </Box>
                <Box gridColumn="span 2">
                  <Typography
                    variant="body2"
                    sx={{
                      py: 1,
                      borderRight: ".3px solid black",
                      fontSize: "12px",
                      textAlign: "center",
                    }}
                  >
                    برند
                  </Typography>
                </Box>
                <Box gridColumn="span 1">
                  <Typography
                    variant="body2"
                    sx={{
                      py: 1,
                      borderRight: ".3px solid black",
                      fontSize: "12px",
                      textAlign: "center",
                    }}
                  >
                    تعداد
                  </Typography>
                </Box>
                <Box gridColumn="span 2">
                  <Typography
                    variant="body2"
                    sx={{
                      py: 1,
                      fontSize: "12px",
                      textAlign: "center",
                    }}
                  >
                    قیمت
                  </Typography>
                </Box>
              </Box>
              {data &&
                data.orders.map((model, i) => {
                  return (
                    <Box
                      key={i}
                      sx={{
                        borderBottom: ".3px solid black",

                        // py: 1,
                      }}
                      display="grid"
                      gridTemplateColumns="repeat(12, 1fr)"
                      // gap={1}
                    >
                      <Box
                        sx={{
                          borderRight: ".3px solid black",
                        }}
                        gridColumn="span 2"
                      >
                        <Typography
                          variant="body2"
                          sx={{
                            py: 1,

                            fontSize: "12px",
                            textAlign: "center",
                          }}
                        >
                          {model.productID}
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          borderRight: ".3px solid black",
                        }}
                        gridColumn="span 5"
                      >
                        <Typography
                          variant="body2"
                          sx={{
                            py: 1,
                            pl: 0.5,
                            fontSize: "12px",
                            textAlign: "left",
                          }}
                        >
                          {model.productName}
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          borderRight: ".3px solid black",
                        }}
                        gridColumn="span 2"
                      >
                        <Typography
                          variant="body2"
                          sx={{
                            py: 1,
                            fontSize: "12px",
                            textAlign: "center",
                          }}
                        >
                          {model.brandName ? model.brandName : "-"}
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          borderRight: ".3px solid black",
                        }}
                        gridColumn="span 1"
                      >
                        <Typography
                          variant="body2"
                          sx={{
                            py: 1,
                            fontSize: "12px",
                            textAlign: "center",
                          }}
                        >
                          {model.orderCount}
                        </Typography>
                      </Box>
                      <Box gridColumn="span 2">
                        <Typography
                          variant="body2"
                          sx={{
                            py: 1,
                            fontSize: "12px",
                            textAlign: "center",
                          }}
                        >
                          {model.discountCost ? toMoney(model.discountCost) : 0}
                        </Typography>
                      </Box>
                    </Box>
                  );
                })}
            </Box>
          )}
        </Box>
      </>
    )
  );
}
